import { Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function SiteFooter() {
  const navigateLinks = [{
    label: "Home",
    to: "/HomePage"
  }, {
    label: "Get a Quote",
    to: "/GetQuotePage"
  }, {
    label: "Services",
    to: "/HomePage"
  }, {
    label: "Portfolio",
    to: "/HomePage"
  }, {
    label: "Contact",
    to: "/GetQuotePage"
  }];
  const collectionLinks = [{
    label: "Precision Mowing",
    to: "/HomePage"
  }, {
    label: "Edge & Trim",
    to: "/HomePage"
  }, {
    label: "Seasonal Cleanup",
    to: "/HomePage"
  }, {
    label: "Turf Management",
    to: "/HomePage"
  }, {
    label: "Commercial Care",
    to: "/HomePage"
  }];
  const atelierLinks = [{
    label: "Service Areas",
    to: "/HomePage"
  }, {
    label: "Maintenance Plans",
    to: "/HomePage"
  }, {
    label: "The Process",
    to: "#"
  }, {
    label: "Request Visit",
    to: "/GetQuotePage"
  }];
  const legalLinks = [{
    label: "Privacy",
    to: "#"
  }, {
    label: "Terms",
    to: "#"
  }, {
    label: "Cookies",
    to: "#"
  }];
  return <section data-section-id="4264" id="site-footer" className="dark bg-background text-foreground pt-[140px] pb-14">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        {}
        <Separator className="bg-primary/40 h-px w-full" />

        {}
        <div className="mt-20 grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-10">
          {}
          <div className="md:col-span-4 lg:col-span-4">
            <Link to="/" className="inline-block">
              <span className="font-default text-3xl font-extrabold tracking-tighter text-foreground" style={{
              letterSpacing: "-0.04em"
            }}>
                ACOSTA'S
              </span>
            </Link>
            <p className="font-default text-base text-muted-foreground mt-6 max-w-xs leading-relaxed">
              The Architect of the Blade. Precision landscaping for the modern estate.
            </p>
            <p className="font-mono text-[13px] text-muted-foreground mt-6 leading-relaxed" style={{
            letterSpacing: "0.02em"
          }}>
              682-320-5738
              <br />
              acostalawncare@gmail.com
            </p>
          </div>

          {}
          <div className="md:col-span-2 lg:col-span-2">
            <p className="font-mono text-[11px] uppercase text-primary mb-6" style={{
            letterSpacing: "0.25em"
          }}>
              [NAV.01]
            </p>
            <ul className="flex flex-col gap-3">
              {navigateLinks.map((item, i) => <li data-index={i} key={item.label}>
                  <Link to={item.to} className="font-default text-sm text-foreground/85 hover:text-primary transition-colors duration-300 relative inline-block group">
                    <span>{item.label}</span>
                    <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-primary transition-all duration-300 group-hover:w-full" />
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="md:col-span-3 lg:col-span-3">
            <p className="font-mono text-[11px] uppercase text-primary mb-6" style={{
            letterSpacing: "0.25em"
          }}>
              [SRV.02]
            </p>
            <ul className="flex flex-col gap-3">
              {collectionLinks.map((item, i) => <li data-index={i} key={item.label}>
                  <Link to={item.to} className="font-default text-sm text-foreground/85 hover:text-primary transition-colors duration-300 relative inline-block group">
                    <span>{item.label}</span>
                    <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-primary transition-all duration-300 group-hover:w-full" />
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="md:col-span-3 lg:col-span-3">
            <p className="font-mono text-[11px] uppercase text-primary mb-6" style={{
            letterSpacing: "0.25em"
          }}>
              [OPS.03]
            </p>
            <ul className="flex flex-col gap-3">
              {atelierLinks.map((item, i) => <li data-index={i} key={item.label}>
                  <Link to={item.to} className="font-default text-sm text-foreground/85 hover:text-primary transition-colors duration-300 relative inline-block group">
                    <span>{item.label}</span>
                    <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-primary transition-all duration-300 group-hover:w-full" />
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <div className="mt-20">
          <Separator className="bg-primary/30 h-px w-full" />

          <div className="mt-8 flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
            {}
            <div className="flex flex-col gap-3 md:flex-row md:items-center md:gap-8">
              <p className="font-mono text-[11px] uppercase text-muted-foreground" style={{
              letterSpacing: "0.25em"
            }}>
                © MMXXV ACOSTA'S LANDSCAPING — ALL RIGHTS RESERVED
              </p>
              <ul className="flex items-center gap-4">
                {legalLinks.map((item, i) => <li data-index={i} key={item.label} className="flex items-center gap-4">
                    <Link to={item.to} className="font-mono text-[11px] uppercase text-muted-foreground hover:text-primary transition-colors duration-300" style={{
                  letterSpacing: "0.2em"
                }}>
                      {item.label}
                    </Link>
                    {i < legalLinks.length - 1 && <span className="text-muted-foreground/35 text-[11px]">·</span>}
                  </li>)}
              </ul>
            </div>

            {}
            <Link to="https://instagram.com" newTab className="group inline-flex items-center gap-3 self-start md:self-auto" aria-label="Instagram @acostas.landscaping">
              <span className="border border-primary/40 group-hover:border-primary p-2 rounded-md transition-colors duration-300">
                <Instagram className="h-4 w-4 text-foreground/85 group-hover:text-primary transition-colors duration-300" strokeWidth={1.5} />
              </span>
              <span className="font-mono text-[11px] uppercase text-foreground/75 group-hover:text-primary transition-colors duration-300" style={{
              letterSpacing: "0.25em"
            }}>
                @acostas.landscaping
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}